/**
 * Minimal Currency List
 *
 * This reduces bundle size from ~11MB to ~7KB
 *
 * Generated on: 2025-06-10T13:14:40.637Z
 * This should be done every time the currency-list package is updated.
 * Original package: currency-list@1.0.8
 * Total currencies: 119
 */

export interface Currency {
  code: string;
  name: string;
  symbol: string;
}

export type CurrencyMap = Record<string, Currency>;

const currencies: CurrencyMap = {
  AFN: {
    code: "AFN",
    name: "Afghan Afghani",
    symbol: "Af"
  },
  ALL: {
    code: "ALL",
    name: "Albanian Lek",
    symbol: "ALL"
  },
  DZD: {
    code: "DZD",
    name: "Algerian Dinar",
    symbol: "DA"
  },
  ARS: {
    code: "ARS",
    name: "Argentine Peso",
    symbol: "AR$"
  },
  AMD: {
    code: "AMD",
    name: "Armenian Dram",
    symbol: "AMD"
  },
  AUD: {
    code: "AUD",
    name: "Australian Dollar",
    symbol: "AU$"
  },
  AZN: {
    code: "AZN",
    name: "Azerbaijani Manat",
    symbol: "man."
  },
  BHD: {
    code: "BHD",
    name: "Bahraini Dinar",
    symbol: "BD"
  },
  BDT: {
    code: "BDT",
    name: "Bangladeshi Taka",
    symbol: "Tk"
  },
  BYN: {
    code: "BYN",
    name: "Belarusian Ruble",
    symbol: "Br"
  },
  BZD: {
    code: "BZD",
    name: "Belize Dollar",
    symbol: "BZ$"
  },
  BOB: {
    code: "BOB",
    name: "Bolivian Boliviano",
    symbol: "Bs"
  },
  BAM: {
    code: "BAM",
    name: "Bosnia-Herzegovina Convertible Mark",
    symbol: "KM"
  },
  BWP: {
    code: "BWP",
    name: "Botswanan Pula",
    symbol: "BWP"
  },
  BRL: {
    code: "BRL",
    name: "Brazilian Real",
    symbol: "R$"
  },
  GBP: {
    code: "GBP",
    name: "British Pound",
    symbol: "£"
  },
  BND: {
    code: "BND",
    name: "Brunei Dollar",
    symbol: "BN$"
  },
  BGN: {
    code: "BGN",
    name: "Bulgarian Lev",
    symbol: "BGN"
  },
  BIF: {
    code: "BIF",
    name: "Burundian Franc",
    symbol: "FBu"
  },
  KHR: {
    code: "KHR",
    name: "Cambodian Riel",
    symbol: "KHR"
  },
  CAD: {
    code: "CAD",
    name: "Canadian Dollar",
    symbol: "CA$"
  },
  CVE: {
    code: "CVE",
    name: "Cape Verdean Escudo",
    symbol: "CV$"
  },
  XAF: {
    code: "XAF",
    name: "Central African CFA Franc",
    symbol: "FCFA"
  },
  CLP: {
    code: "CLP",
    name: "Chilean Peso",
    symbol: "CL$"
  },
  CNY: {
    code: "CNY",
    name: "Chinese Yuan",
    symbol: "CN¥"
  },
  COP: {
    code: "COP",
    name: "Colombian Peso",
    symbol: "CO$"
  },
  KMF: {
    code: "KMF",
    name: "Comorian Franc",
    symbol: "CF"
  },
  CDF: {
    code: "CDF",
    name: "Congolese Franc",
    symbol: "CDF"
  },
  CRC: {
    code: "CRC",
    name: "Costa Rican Colón",
    symbol: "₡"
  },
  HRK: {
    code: "HRK",
    name: "Croatian Kuna",
    symbol: "kn"
  },
  CZK: {
    code: "CZK",
    name: "Czech Koruna",
    symbol: "Kč"
  },
  DKK: {
    code: "DKK",
    name: "Danish Krone",
    symbol: "Dkr"
  },
  DJF: {
    code: "DJF",
    name: "Djiboutian Franc",
    symbol: "Fdj"
  },
  DOP: {
    code: "DOP",
    name: "Dominican Peso",
    symbol: "RD$"
  },
  EGP: {
    code: "EGP",
    name: "Egyptian Pound",
    symbol: "EGP"
  },
  ERN: {
    code: "ERN",
    name: "Eritrean Nakfa",
    symbol: "Nfk"
  },
  EEK: {
    code: "EEK",
    name: "Estonian Kroon",
    symbol: "Ekr"
  },
  ETB: {
    code: "ETB",
    name: "Ethiopian Birr",
    symbol: "Br"
  },
  EUR: {
    code: "EUR",
    name: "Euro",
    symbol: "€"
  },
  GEL: {
    code: "GEL",
    name: "Georgian Lari",
    symbol: "GEL"
  },
  GHS: {
    code: "GHS",
    name: "Ghanaian Cedi",
    symbol: "GH₵"
  },
  GTQ: {
    code: "GTQ",
    name: "Guatemalan Quetzal",
    symbol: "GTQ"
  },
  GNF: {
    code: "GNF",
    name: "Guinean Franc",
    symbol: "FG"
  },
  HNL: {
    code: "HNL",
    name: "Honduran Lempira",
    symbol: "HNL"
  },
  HKD: {
    code: "HKD",
    name: "Hong Kong Dollar",
    symbol: "HK$"
  },
  HUF: {
    code: "HUF",
    name: "Hungarian Forint",
    symbol: "Ft"
  },
  ISK: {
    code: "ISK",
    name: "Icelandic Króna",
    symbol: "Ikr"
  },
  INR: {
    code: "INR",
    name: "Indian Rupee",
    symbol: "Rs"
  },
  IDR: {
    code: "IDR",
    name: "Indonesian Rupiah",
    symbol: "Rp"
  },
  IRR: {
    code: "IRR",
    name: "Iranian Rial",
    symbol: "IRR"
  },
  IQD: {
    code: "IQD",
    name: "Iraqi Dinar",
    symbol: "IQD"
  },
  ILS: {
    code: "ILS",
    name: "Israeli New Shekel",
    symbol: "₪"
  },
  JMD: {
    code: "JMD",
    name: "Jamaican Dollar",
    symbol: "J$"
  },
  JPY: {
    code: "JPY",
    name: "Japanese Yen",
    symbol: "¥"
  },
  JOD: {
    code: "JOD",
    name: "Jordanian Dinar",
    symbol: "JD"
  },
  KZT: {
    code: "KZT",
    name: "Kazakhstani Tenge",
    symbol: "KZT"
  },
  KES: {
    code: "KES",
    name: "Kenyan Shilling",
    symbol: "Ksh"
  },
  KWD: {
    code: "KWD",
    name: "Kuwaiti Dinar",
    symbol: "KD"
  },
  LVL: {
    code: "LVL",
    name: "Latvian Lats",
    symbol: "Ls"
  },
  LBP: {
    code: "LBP",
    name: "Lebanese Pound",
    symbol: "LB£"
  },
  LYD: {
    code: "LYD",
    name: "Libyan Dinar",
    symbol: "LD"
  },
  LTL: {
    code: "LTL",
    name: "Lithuanian Litas",
    symbol: "Lt"
  },
  MOP: {
    code: "MOP",
    name: "Macanese Pataca",
    symbol: "MOP$"
  },
  MKD: {
    code: "MKD",
    name: "Macedonian Denar",
    symbol: "MKD"
  },
  MGA: {
    code: "MGA",
    name: "Malagasy Ariary",
    symbol: "MGA"
  },
  MYR: {
    code: "MYR",
    name: "Malaysian Ringgit",
    symbol: "RM"
  },
  MUR: {
    code: "MUR",
    name: "Mauritian Rupee",
    symbol: "MURs"
  },
  MXN: {
    code: "MXN",
    name: "Mexican Peso",
    symbol: "MX$"
  },
  MDL: {
    code: "MDL",
    name: "Moldovan Leu",
    symbol: "MDL"
  },
  MAD: {
    code: "MAD",
    name: "Moroccan Dirham",
    symbol: "MAD"
  },
  MZN: {
    code: "MZN",
    name: "Mozambican Metical",
    symbol: "MTn"
  },
  MMK: {
    code: "MMK",
    name: "Myanmar Kyat",
    symbol: "MMK"
  },
  NAD: {
    code: "NAD",
    name: "Namibian Dollar",
    symbol: "N$"
  },
  NPR: {
    code: "NPR",
    name: "Nepalese Rupee",
    symbol: "NPRs"
  },
  TWD: {
    code: "TWD",
    name: "New Taiwan Dollar",
    symbol: "NT$"
  },
  NZD: {
    code: "NZD",
    name: "New Zealand Dollar",
    symbol: "NZ$"
  },
  NIO: {
    code: "NIO",
    name: "Nicaraguan Córdoba",
    symbol: "C$"
  },
  NGN: {
    code: "NGN",
    name: "Nigerian Naira",
    symbol: "₦"
  },
  NOK: {
    code: "NOK",
    name: "Norwegian Krone",
    symbol: "Nkr"
  },
  OMR: {
    code: "OMR",
    name: "Omani Rial",
    symbol: "OMR"
  },
  PKR: {
    code: "PKR",
    name: "Pakistani Rupee",
    symbol: "PKRs"
  },
  PAB: {
    code: "PAB",
    name: "Panamanian Balboa",
    symbol: "B/."
  },
  PYG: {
    code: "PYG",
    name: "Paraguayan Guarani",
    symbol: "₲"
  },
  PEN: {
    code: "PEN",
    name: "Peruvian Sol",
    symbol: "S/."
  },
  PHP: {
    code: "PHP",
    name: "Philippine Peso",
    symbol: "₱"
  },
  PLN: {
    code: "PLN",
    name: "Polish Zloty",
    symbol: "zł"
  },
  QAR: {
    code: "QAR",
    name: "Qatari Rial",
    symbol: "QR"
  },
  RON: {
    code: "RON",
    name: "Romanian Leu",
    symbol: "RON"
  },
  RUB: {
    code: "RUB",
    name: "Russian Ruble",
    symbol: "RUB"
  },
  RWF: {
    code: "RWF",
    name: "Rwandan Franc",
    symbol: "RWF"
  },
  SAR: {
    code: "SAR",
    name: "Saudi Riyal",
    symbol: "SR"
  },
  RSD: {
    code: "RSD",
    name: "Serbian Dinar",
    symbol: "din."
  },
  SGD: {
    code: "SGD",
    name: "Singapore Dollar",
    symbol: "S$"
  },
  SOS: {
    code: "SOS",
    name: "Somali Shilling",
    symbol: "Ssh"
  },
  ZAR: {
    code: "ZAR",
    name: "South African Rand",
    symbol: "R"
  },
  KRW: {
    code: "KRW",
    name: "South Korean Won",
    symbol: "₩"
  },
  LKR: {
    code: "LKR",
    name: "Sri Lankan Rupee",
    symbol: "SLRs"
  },
  SDG: {
    code: "SDG",
    name: "Sudanese Pound",
    symbol: "SDG"
  },
  SEK: {
    code: "SEK",
    name: "Swedish Krona",
    symbol: "Skr"
  },
  CHF: {
    code: "CHF",
    name: "Swiss Franc",
    symbol: "CHF"
  },
  SYP: {
    code: "SYP",
    name: "Syrian Pound",
    symbol: "SY£"
  },
  TZS: {
    code: "TZS",
    name: "Tanzanian Shilling",
    symbol: "TSh"
  },
  THB: {
    code: "THB",
    name: "Thai Baht",
    symbol: "฿"
  },
  TOP: {
    code: "TOP",
    name: "Tongan Paʻanga",
    symbol: "T$"
  },
  TTD: {
    code: "TTD",
    name: "Trinidad & Tobago Dollar",
    symbol: "TT$"
  },
  TND: {
    code: "TND",
    name: "Tunisian Dinar",
    symbol: "DT"
  },
  TRY: {
    code: "TRY",
    name: "Turkish Lira",
    symbol: "TL"
  },
  USD: {
    code: "USD",
    name: "US Dollar",
    symbol: "$"
  },
  UGX: {
    code: "UGX",
    name: "Ugandan Shilling",
    symbol: "USh"
  },
  UAH: {
    code: "UAH",
    name: "Ukrainian Hryvnia",
    symbol: "₴"
  },
  AED: {
    code: "AED",
    name: "United Arab Emirates Dirham",
    symbol: "AED"
  },
  UYU: {
    code: "UYU",
    name: "Uruguayan Peso",
    symbol: "$U"
  },
  UZS: {
    code: "UZS",
    name: "Uzbekistani Som",
    symbol: "UZS"
  },
  VEF: {
    code: "VEF",
    name: "Venezuelan Bolívar",
    symbol: "Bs.F."
  },
  VND: {
    code: "VND",
    name: "Vietnamese Dong",
    symbol: "₫"
  },
  XOF: {
    code: "XOF",
    name: "West African CFA Franc",
    symbol: "CFA"
  },
  YER: {
    code: "YER",
    name: "Yemeni Rial",
    symbol: "YR"
  },
  ZMK: {
    code: "ZMK",
    name: "Zambian Kwacha",
    symbol: "ZK"
  },
  ZWL: {
    code: "ZWL",
    name: "Zimbabwean Dollar",
    symbol: "ZWL$"
  }
};

export const currencyList = {
  /**
   * Get a single currency by code
   * @param code - Currency code (e.g., "USD")
   * @returns Currency object or null
   */
  get: (code: string): Currency | null => currencies[code] || null,

  /**
   * Get all currencies
   * @returns All currencies
   */
  getAll: (): CurrencyMap => currencies,

  /**
   * Get all currency codes
   * @returns Array of currency codes
   */
  getCodes: (): Array<string> => Object.keys(currencies),

  /**
   * Check if a currency code exists
   * @param code - Currency code to check
   * @returns True if currency exists
   */
  exists: (code: string): boolean => !!currencies[code]
};

export default currencyList;
